import React from "react"
import { Card, CardContent, Typography, makeStyles, useTheme } from "@material-ui/core"
import { Chart } from "react-google-charts"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { Skeleton } from "@material-ui/lab"

const useStyles = makeStyles((theme) => ({
	cardBody: {
		padding: 0,
		"&:last-child": {
			paddingBottom: 0,
		},
	},
	title: {
		color: theme.palette.grey.D300,
		fontWeight: 600,
		padding: "4px 10px",
	},
	skeletonWrapper: {
		padding: 15,
	},
	NoData: {
		minHeight: 200,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
}))

const FileTypesGraph = ({ data = [], isLoading = false }) => {
	const classes = useStyles()
	const theme = useTheme()
	const [t] = useTranslation("global")

	const options = {
		title: "",
		pieHole: 0.4,
		is3D: false,
		legend: "bottom",
		pieSliceText: "none",
		pieHole: 0.8,
		animation: {
			startup: true,
			duration: 1000,
			easing: "inAndOut",
		},
		colors: [
			theme.palette.dashboard.D10,
			theme.palette.dashboard.D20,
			theme.palette.dashboard.D30,
			theme.palette.dashboard.D40,
			theme.palette.dashboard.D50,
			theme.palette.dashboard.D60,
			theme.palette.dashboard.D70,
			theme.palette.dashboard.D80,
		],
		chartArea: { left: 10, top: 0, right: 10, width: "100%", height: "75%" },
	}

	return (
		<Card className={classes.root}>
			<CardContent className={classes.cardBody}>
				<Typography variant="subtitle1" className={classes.title}>
					{t("dashboard.fileTypesText")}
				</Typography>
				{isLoading ? (
					<div className={classes.skeletonWrapper}>
						<Skeleton variant="rect" width={"100%"} height={170} />
					</div>
				) : data?.length ? (
					<Chart chartType="PieChart" width="100%" data={data} options={options} />
				) : (
					<Typography variant="subtitle1" className={classes.NoData}>
						{t("dashboard.noDataFound")}
					</Typography>
				)}
			</CardContent>
		</Card>
	)
}

export default FileTypesGraph
